import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";

import { editOrganisation as editOrganisationAPI } from "api/organisations";
import { organisationsKeys } from "api/organisations/queries";
import {
  EditOrganisationType,
  OrganisationsType,
} from "api/organisations/types";
import AppDialog from "components/AppDialog";
import ModalHeader from "components/AppDialog/ModalHeader";

import OrganisationForm, { OrganisationFormValues } from "./OrganisationForm";

// LOGIC:

// TYPES:

interface EditOrganisationModalProps {
  isOpen: boolean;
  handleClose: () => void;
  organisation: OrganisationsType | undefined;
}

const EditOrganisationModal = ({
  isOpen,
  handleClose,
  organisation,
}: EditOrganisationModalProps) => {
  const queryClient = useQueryClient();

  const initialValues: OrganisationFormValues = {
    name: organisation?.name || "",
    email: organisation?.email || "",
    leadSource: organisation?.leadSource || "",
    brand: organisation?.brand || null,
    partnerPayout: {
      active: organisation?.partnerPayout.active || false,
      type: organisation?.partnerPayout.type || "they-invoice",
      value: organisation?.partnerPayout.value || null,
    },
  };

  const { mutateAsync: editOrganisation, status } = useMutation(
    async (data: EditOrganisationType) => {
      const res = await editOrganisationAPI(data);
      await queryClient.invalidateQueries(organisationsKeys.list());
      return res.data;
    },
  );

  const handleSubmit = async (values: OrganisationFormValues) => {
    const mappedValues: EditOrganisationType = {
      _id: organisation!._id,
      ...values,
    };
    await editOrganisation(mappedValues, {
      onSuccess: () => handleClose(),
    });
  };

  return (
    <AppDialog open={isOpen} onClose={handleClose} maxWidth="lg">
      <ModalHeader
        title="Edit Organisation"
        subtitle="Update organisation information and settings."
      />
      <OrganisationForm
        submitStatus={status}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        initialValues={initialValues}
      />
    </AppDialog>
  );
};

export default EditOrganisationModal;
